(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-google-store-widget"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const footer = document.querySelector('.footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    const slot = document.createElement('div');
    slot.className = 'bp-footer-badge-slot';
    slot.setAttribute('aria-hidden', 'true');
    footer.appendChild(slot);
    const observer = new IntersectionObserver(entries => {
      document.documentElement.classList.toggle('bp-footer-badge-visible', entries[0].isIntersecting && entries[0].intersectionRatio >= .99);
    }, {threshold: [0, 1]});
    observer.observe(slot);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-mobile-floats"] && !Shopify.designMode) return;
  try {
    (() => {
  const patch = () => {
    const widget = document.querySelector('whatsup-whatsapp-button');
    const shadow = widget?.shadowRoot;
    if (!shadow || shadow.querySelector('[data-bp-round-style]')) return;
    const link = shadow.querySelector('a.whatsup-whatsapp-button');
    if (!link) return;
    const productPage = document.querySelector('[data-bp-float-settings]')?.dataset.productPage === 'true';
    const style = document.createElement('style');
    style.dataset.bpRoundStyle = 'true';
    style.textContent = `
      .bp-whatsapp-round-icon { display: none; }
      @media (min-width: 0px) {
        a.whatsup-whatsapp-button {
          width: 44px;
          height: 44px;
          right: 16px;
          bottom: calc(var(--bp-float-bottom, 110px) + env(safe-area-inset-bottom));
          border-radius: 50%;
          background: #168b43;
          display: flex;
          align-items: center;
          justify-content: center;
          scale: 1;
          transform: none;
          filter: none;
          box-shadow: 0 4px 14px rgb(0 0 0 / 22%);
          z-index: 100;
        }
        a.whatsup-whatsapp-button:hover, a.whatsup-whatsapp-button:active { transform: none; }
        a.whatsup-whatsapp-button img { display: none; }
        a.whatsup-whatsapp-button:focus-visible { outline: 3px solid #25243a; outline-offset: 3px; }
        .bp-whatsapp-round-icon { display: block; width: 28px; height: 28px; color: #fff; }
      }
    `;
    shadow.appendChild(style);
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('class', 'bp-whatsapp-round-icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = '<path d="M20.5 11.6a8.5 8.5 0 0 1-12.7 7.4L3 20.5l1.5-4.7A8.5 8.5 0 1 1 20.5 11.6Z" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M8.4 7.6c-.6 0-1.2.8-1.2 1.6 0 2.7 3.3 6 6 6 .8 0 1.6-.6 1.6-1.2l-2-1.1-.9.8c-1.3-.6-2.2-1.5-2.8-2.8l.8-.9-1.1-2Z" fill="currentColor"/>';
    link.appendChild(svg);
  };
  const wait = () => {
    if (!window.customElements) return;
    customElements.whenDefined('whatsup-whatsapp-button').then(patch);
    patch();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait, {once: true});
  else wait();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-product-layout-fix"] && !Shopify.designMode) return;
  try {
    (() => {
  const pinAgent = () => {
    const shadow = document.querySelector('#ads-agent-host')?.shadowRoot;
    if (!shadow) return false;
    if (!shadow.querySelector('[data-bp-agent-position]')) {
      const style = document.createElement('style');
      style.dataset.bpAgentPosition = 'true';
      style.textContent = `
        [data-testid="entrypoint"] {
          position: fixed !important;
          left: 24px !important;
          right: auto !important;
          top: auto !important;
          bottom: 140px !important;
          margin: 0 !important;
          transform: none !important;
          translate: none !important;
          align-items: flex-start !important;
          max-width: min(360px, calc(100vw - 48px)) !important;
        }
        [data-testid="entrypoint"] > [role="button"] { max-width: 100% !important; }
        @media (min-width: 0px) {
          [data-testid="floating-view"] {
            width: calc(100vw - 24px) !important;
            max-width: calc(100vw - 24px) !important;
            left: 12px !important;
            right: 12px !important;
            top: 12px !important;
            height: calc(100dvh - 24px) !important;
            max-height: calc(100dvh - 24px) !important;
            margin: 0 !important;
            transform: none !important;
            border-radius: 18px !important;
          }
          [data-testid="entrypoint"] {
            left: 16px !important;
            right: auto !important;
            bottom: calc(var(--bp-float-bottom, 86px) + env(safe-area-inset-bottom, 0px)) !important;
            width: 44px !important;
            height: 44px !important;
            max-width: 44px !important;
            align-items: center !important;
            transition: none !important;
            animation: none !important;
          }
          [data-testid="entrypoint"] > [role="button"] { background:#fff!important;color:#c83842!important;border:1px solid #e8c8cc!important;box-shadow:0 3px 12px #231e2920!important; }
          [data-testid="entrypoint"] > [role="button"]::after { content:'';position:absolute;inset:0;z-index:30;display:grid;place-items:center;font:700 24px/1 Arial;color:#c83842!important;background:#fff!important;border-radius:50%;pointer-events:none; }
          [data-testid="entrypoint"] > [role="button"] > div { visibility:hidden!important; }
          [data-testid="entrypoint"] > [role="button"] > div:first-child { background:#fff!important; }
          #root { pointer-events: none; }
          [data-testid="entrypoint"],[data-testid="floating-view"] { pointer-events: auto; }
          [data-testid="entrypoint"] svg { color: #231e29 !important; fill: #231e29 !important; }
          [data-testid="entrypoint"] > [role="button"] > div:first-child > div:first-child { background:#fff !important; }
          [data-testid="entrypoint"] > button { display: none !important; }
          [data-testid="entrypoint"] > [role="button"] {
            width: 44px !important;
            height: 44px !important;
            min-width: 44px !important;
            border: 0 !important;
            border-radius: 50% !important;
            transform: none !important;
            transition: none !important;
            animation: none !important;
          }
          [data-testid="entrypoint"] > [role="button"] > div:first-child {
            width: 44px !important;
            height: 44px !important;
            padding: 4px !important;
            gap: 0 !important;
            border-radius: 50% !important;
            background: #fff !important;
            border: 2px solid #c83842 !important;
            color: #231e29 !important;
          }
          [data-testid="entrypoint"] > [role="button"] > div:first-child > div:nth-child(2),
          [data-testid="entrypoint"] > [role="button"] > div:nth-child(2) { display: none !important; }
          [data-testid="entrypoint"] > [role="button"] > div:first-child > div:first-child {
            width: 44px !important;
            height: 44px !important;
          }
        }
        @media (min-width: 750px) {
          [data-testid="floating-view"] { width:min(420px,calc(100vw - 48px))!important;max-width:420px!important;left:auto!important;right:24px!important;top:auto!important;bottom:90px!important;height:min(640px,calc(100dvh - 120px))!important;max-height:calc(100dvh - 120px)!important; }
        }
      `;
      style.textContent += `
[data-testid="entrypoint"] > [role="button"] {position:relative!important;overflow:visible!important;border:2px solid #c83842!important;box-shadow:0 4px 20px #c8384230!important;}
[data-testid="entrypoint"] > [role="button"]::before{content:'Shop AI';position:absolute;left:0;bottom:50px;white-space:nowrap;background:#382434;color:#fff;border-radius:8px;padding:5px 8px;font:700 11px/1.3 Arial;pointer-events:none;}
@media(prefers-reduced-motion:no-preference){[data-testid="entrypoint"] > [role="button"]{animation:bp-ai-glow 3s ease-in-out 3!important;}@keyframes bp-ai-glow{50%{box-shadow:0 0 0 7px #c838421b!important;}}}
`;
const trigger=shadow.querySelector('[data-testid="entrypoint"] > [role="button"]');if(trigger)trigger.setAttribute('aria-label','Open BluParty AI shopping assistant');
style.textContent += `
[data-testid="entrypoint"] > [role="button"]::after{content:''!important;inset:3px!important;border-radius:50%;background:radial-gradient(circle at 32% 25%,#ffffffd9 0%,transparent 28%),radial-gradient(circle at 65% 70%,#ffb8ab 0%,transparent 52%),conic-gradient(from 0deg,#c83842,#ffb5bf,#8764da,#ed809a,#c83842)!important;box-shadow:inset -3px -4px 8px #73204460,inset 2px 2px 5px #ffffffb0;animation:bp-orb-turn 6s linear infinite!important;}
[data-testid="entrypoint"] > [role="button"]::before{content:'Shop AI'!important;font-family:Fredoka,Arial,sans-serif!important;}
@keyframes bp-orb-turn{to{transform:rotate(360deg)}}
@media(prefers-reduced-motion:reduce){[data-testid="entrypoint"] > [role="button"]::after{animation:none!important}}
`;
shadow.appendChild(style);
    }
    return true;
  };
  const watchAgent = () => {
    if (pinAgent()) return;
    const observer = new MutationObserver(() => {
      if (pinAgent()) observer.disconnect();
    });
    observer.observe(document.body, {childList:true, subtree:true});
    setTimeout(() => observer.disconnect(), 30000);
  };
  const init = () => {
    watchAgent();
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(root => {
      const details = root.querySelector('.bp-product-details');
      const panel = root.querySelector('.product__info-container');
      if (details && panel && !panel.contains(details)) panel.appendChild(details);
    });
    const header = document.querySelector('.section-header');
    const update = () => {
      const height = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--bp-sticky-top', (height + 20) + 'px');
    };
    update();
    if (header && 'ResizeObserver' in window) new ResizeObserver(update).observe(header);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-product-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    scope.querySelectorAll('product-info[id^="MainProduct-"]').forEach(root => {
      const dock = root.querySelector('[data-bp-cart-dock]');
      if (!dock || dock.dataset.ready) return;
      dock.dataset.ready = 'true';
      const button = dock.querySelector('[data-bp-dock-submit]');
      const price = dock.querySelector('[data-bp-dock-price]');
      const compare = dock.querySelector('[data-bp-dock-compare]');
      const primary = () => root.querySelector('.product-form__submit');
      const sync = () => {
        const source = primary();
        const disabled = !source || source.disabled || source.getAttribute('aria-disabled') === 'true';
        if (button.disabled !== disabled) button.disabled = disabled;
        const label = source?.querySelector('span')?.textContent.trim();
        if (label && button.textContent.trim() !== label) button.textContent = label;
        const wrapper = root.querySelector('[id^="price-"] .price');
        const current = wrapper?.querySelector(wrapper.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        const text = current?.textContent.trim();
        if (text && price.textContent.trim() !== text) {
          price.textContent = text;
          if (!matchMedia('(prefers-reduced-motion:reduce)').matches) price.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'ease-out'});
        }
        const sale = wrapper?.classList.contains('price--on-sale');
        const old = sale ? wrapper.querySelector('.price__sale .price-item--regular')?.textContent.trim() : '';
        if (compare && compare.textContent.trim() !== (old || '')) compare.textContent = old || '';
        if (compare && compare.hidden !== !old) compare.hidden = !old;
      };
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      button.addEventListener('click', () => {
        const source = primary();
        if (!source || button.disabled) return;
        const form = source.form || source.closest('form');
        if (form && !form.reportValidity()) return;
        source.click();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
